export const projects = [
  {
    id: 0,
    title: 'Playable Demonstration of a Basketball Video Game "Check up top"',
    stack:
      'During my graduation project, I had the chance to gain experience in Unreal Engine 5, and work with C++, Blueprint, and explore GAS & Learning Agent plugins.',
    endDate: 'January 2024 - July 2024',
    image: 'images/checkuptop.png',
    link: '',
    textStyle: 'light',
    gitHubLink: '',
  },
  {
    id: 1,
    title: "GHOSTWIELD's Portfolio",
    stack:
      'Portfolio built using ReactJs, Three.js, R3F, and React Three Drei.',
    endDate: 'September 2023',
    image: 'images/ghostwield.png',
    link: 'https://ghostwield.com/',
    textStyle: 'light',
    gitHubLink: '',
  },
  {
    id: 2,
    title: "Game Shift's Website",
    stack:
      'Built using ReactJs, Three.js, R3F, React Three Drei, Node.js, Express and Nodemailer as a custom email server.',
    endDate: 'June 2023 - August 2023',
    image: 'images/gameshift.png',
    link: 'https://wearegameshift.com/',
    textStyle: 'light',
    gitHubLink: '',
  },
  {
    id: 3,
    title: 'NFT Marketplace - College project',
    stack:
      'Built using Spring Boot, Eureka, Microservices, Angular, Solidity contract, Geth, Alchemy, and MongoDB Atlas for data storage. Users connect MetaMask to mint NFTs. Frontend on Vercel; full deployment in progress.',
    endDate: 'April 2023',
    image: 'images/nftmarketplace.png',
    link: 'https://nftmarketplace-client-mvmd.vercel.app/',
    textStyle: 'dark',
    gitHubLink: 'https://github.com/najlae01/nftmarketplace-client/',
  },
  {
    id: 4,
    title: 'MyMedia - Hobby project',
    stack:
      'Built using ReactJs, Node.js, Express, MongoDB, and deployed To Vercel.',
    endDate: 'July 2022',
    image: 'images/myMedia.png',
    link: 'https://media-frontend-ymug.vercel.app/',
    textStyle: 'dark',
    gitHubLink: 'https://github.com/najlae01/Media_frontend',
  },
]
